import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`I consider myself to be a good team player, a good listener, and a good leader, if need be. I also have a good sense of humour, too bad this is supposed to be a somewhat formal portfolio.`}</p>
    </blockquote>
    <p>{`I am an open-minded individual who consistently strives to attain new knowledge and new experiences. Curiosity has always pushed me forward to try new things and I, without fail, have the perseverance to finish what I start.
Apart from the education at universities in Romania I have done one semester in Krakow in Poland and 1 year of study in the Netherlands, both part of an ERASMUS scholarship. I have also worked on personal projects, and I am always looking for new challenges.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      